import api from '@/services/api'

interface StoreContactAttributes {
  name: string
  email: string
  phone: string
  subject?: string
  message: string
  form: string
}

interface StoreContactBody {
  name: string
  email: string
  phone: string
  subject?: string
  message: string
  form: string
}

const createBody = (attributes: StoreContactAttributes): StoreContactBody => {
  return {
    name: attributes.name,
    email: attributes.email,
    phone: attributes.phone,
    subject: attributes.subject,
    message: attributes.message,
    form: attributes.form,
  }
}

export const sendStoreContactEmail = async (
  attributes: StoreContactAttributes,
) => {
  const response = await api.post(
    '/store_contact/send_emails',
    createBody(attributes),
  )
  return response
}

export default sendStoreContactEmail
